import { CORE_FRONTEND_PERMISSIONS_DISABLED } from "./corePermissionsFlags";

/**
 * Returns whether the current user should be treated as having `action`.
 * When {@link CORE_FRONTEND_PERMISSIONS_DISABLED} is true, always returns true (for defined actions).
 */
export function coreHasPermission(permissionList, action) {
  if (CORE_FRONTEND_PERMISSIONS_DISABLED) {
    return true;
  }
  if (action === undefined || action === null || action === "") {
    return true;
  }
  if (!permissionList || !Array.isArray(permissionList)) {
    return false;
  }
  return permissionList.includes(action);
}
